/* global axios */
// NOTICE: KAPTION-INTEGRATION
export const getNewConversationDefaults = (accountId, inboxId) =>
  axios.get(`/api/v1/accounts/${accountId}/kaption_new_conversation_defaults`, {
    params: inboxId ? { inbox_id: inboxId } : {},
  });
